import React from 'react';

import FilterChip from './FilterChip';

import { useFilterCards } from 'buyside/util/filter/formatFilter';

import styles from './indexFilterChipsStyles.scss';

const IndexFilterChips: React.FC = (): React.ReactElement | null => {
  const filterCards = useFilterCards();

  if (!filterCards.length) return null;

  return (
    <div className={styles.container}>
      <div className={styles.chipContainer}>
        {filterCards.map(
          ({
            paramName,
            paramValue,
            categoryDisplayText,
            valueDisplayText
          }): React.ReactElement => (
            <FilterChip
              key={`${categoryDisplayText}-${valueDisplayText}`}
              label={categoryDisplayText}
              value={valueDisplayText}
              paramName={paramName}
              paramValue={paramValue}
            />
          )
        )}
      </div>
    </div>
  );
};

export default IndexFilterChips;
